import {useState} from 'react'

/**
 * Group Radio button component
 *
 * @param radios
 * @param group
 * @param onChange
 * @returns {JSX.Element}
 * @constructor
 */
const GroupRadioButton = ({radios, group, onChange}) => {


	return (
		<div className='reponses row'>

			{
				radios.map((value, index) => {
					return <div onClick={() => onChange(index, group)} key={index}
								className={`col-xs-6 col-lg-${(12 / radios.length)} rep ${value.is_selected ? 'selected' : ''} `}>
						<span className={`picto ${value.icon_code} `}></span>
						<span className="label">
                      <span style={{textAlign: 'center'}}>{value.libelle}</span>

							{value.infobulle != '' && <span className="infobulle_picto">
                          <span>&nbsp;</span>
                          <span className="infobulle"> {value.infobulle}</span>
                      </span>}

                  </span>
					</div>
				})
			}
		</div>
	);
	return <div></div>;
};

export default GroupRadioButton;
